module.exports = __webpack_public_path__ + "static/media/ye.20c6e27f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ye.svg
// module id = 980
// module chunks = 0